import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Card} from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { LAYOUT } from 'constants.js';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import Clamp from 'components/clamp';
import _ from 'lodash';
import PropTypes from 'prop-types';

const Bio = ({user, ...props}) => {
  const {email, mobile, profile, studentProfile, academicBatch, academicRecord} = user;
  const name = (profile.lastName && profile.lastName!=="")?`${profile.firstName} ${profile.lastName}`:`${profile.firstName}`;
  let profilePicUrl = '/img/profile/default-neutral.png';
  if(profile.profilePic && profile.profilePic!==""){
    profilePicUrl = profile.profilePic;
  }else if(profile.gender && profile.gender!==""){
    profilePicUrl = (profile.gender.toLowerCase() === "male")?`/img/profile/default-male.png`:`/img/profile/default-female.png`;
  }
  
  //const enrollemntBatch = studentProfile.enrollmentBatchId;
  const ug = _.find(academicRecord || [],{gradlevelId:'ug'}) || {}
  
  return (
    <>
      <Card>
        <Card.Body className="mb-n5">
          <div className="d-flex align-items-center flex-column mb-1">
            <div className="mb-5 d-flex align-items-center flex-column">
              <div className="sw-13 position-relative mb-3">
                {profilePicUrl !=="" && <img src={profilePicUrl} className="img-fluid rounded-xl" alt="thumb" style={{height:"104px",width:"104px"}}/>}
              </div>
              <div className="h5 mb-1">{name}</div>
              { !_.isEmpty(ug) && 
                <div>
                {/*<div className="text-medium text-center text-muted">{`${ug.courseInfo.abbv}, ${gradData.branch}`}</div>*/}
                <div className="text-medium text-center text-muted">{`${ug.courseInfo.abbv}, ${ug.joiningYear} - ${ug.qualifyingYear}`}</div>
                <div className="text-medium text-center text-muted">{`${ug.qualifyingInstitution}, ${ug.qualifyingInstitutionCity}`}</div>
              </div>
              }
            </div>
            {/*
            <div className="d-flex flex-row justify-content-between w-100 w-sm-50 w-xl-100">
              <Button variant="primary" className="w-100 me-2">
                Connect
              </Button>
              <Button variant="outline-primary" className="w-100 me-2">
                Message
              </Button>
              <Button variant="outline-primary" className="btn-icon btn-icon-only">
                <CsLineIcons icon="more-horizontal" />
              </Button>
            </div>
            */}
          </div>
          {/*
          <div className="mb-5">
            <p className="text-medium text-center mb-3" style={{color:"#cf9a04",textTransform:"uppercase"}}>Preferred / Suited Domains</p>
            <Row className="g-0 align-items-center mb-2">
              <Col xs="auto">
                <div className="border border-primary sw-4 sh-4 rounded-xl d-flex justify-content-center align-items-center">
                  <CsLineIcons icon="code" className="text-primary" size="18" />
                </div>
              </Col>
              <Col className="ps-3">
                <Row className="g-0">
                  <Col>
                    <div className="sh-5 d-flex align-items-center lh-1-25">Engineering - Backend Development</div>
                  </Col>
                </Row>
              </Col>
            </Row>
            
            <Row className="g-0 align-items-center mb-2">
              <Col xs="auto">
                <div className="border border-primary sw-4 sh-4 rounded-xl d-flex justify-content-center align-items-center">
                  <CsLineIcons icon="boxes" className="text-primary" size="18" />
                </div>
              </Col>
              <Col className="ps-3">
                <Row className="g-0">
                  <Col>
                    <div className="sh-5 d-flex align-items-center lh-1-25">Product Management</div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          */}
          <div className="mb-5">
            <p className="text-small text-muted mb-2">CONTACT</p>
            {/* 
            <NavLink to="#" className="d-block body-link mb-1">
              <CsLineIcons icon="screen" className="me-2" size="17" />
              <span className="align-middle">sagarsrivastava.in</span>
            </NavLink>
            */}
            { email && email!=="" &&
            <NavLink to="#" className="d-block body-link mb-1">
              <CsLineIcons icon="email" className="me-2" size="17" />
              <span className="align-middle">{email}</span>
            </NavLink>
            }
            { mobile && mobile!=="" &&
            <NavLink to="#" className="d-block body-link mb-1">
              <CsLineIcons icon="phone" className="me-2" size="17" />
              <span className="align-middle">+91 {mobile}</span>
            </NavLink>
            }
          </div>
          { profile.aboutMe && profile.aboutMe !=="" &&
          <div className="mb-5">
            <p className="text-small text-muted mb-2">COVER LINE</p>
            <p>{profile.aboutMe}</p>
          </div>
          }
          { profile.hobbies && profile.hobbies !=="" &&
          <div className="mb-5">
            <p className="text-small text-muted mb-2">INTERESTS & HOBBIES</p>
            <p>{profile.hobbies}</p>
          </div>
          }
        </Card.Body>
      </Card>
    </>
  );
};

export default Bio;
Bio.propTypes = {
  user: PropTypes.object.isRequired,
}